import {Injectable} from '@angular/core';
import {ActiveState, EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import { ZnsAPI } from '@etop/api/shop/zns.api';
import {CursorPaging, ShopOA} from '@etop/models';

export interface StateZOAConnection extends EntityState<ShopOA, string>, ActiveState {
  ui: {
    paging: CursorPaging;
    filter: ZnsAPI.GetOAFilter;
    currentPage: number;
  };
}

const initialState = {
  ui: {
    paging: null,
    filter: null,
    currentPage: 1,
  },
};

@Injectable({
  providedIn: 'root'
})
@StoreConfig({name: 'shopOAConnection', resettable: true})
export class ZOAConnectionStore extends EntityStore<StateZOAConnection> {
  constructor() {
    super(initialState);
  }
}
